// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lI09","right":"styles_right__2osfE"};